import * as React from "react";
import DialogContext from "./DialogContext";
import { DialogContextInterface, DialogInterface } from "./DialogInterface";

const useDialogProps = (): DialogContextInterface => {
  const [dialogs, setDialogProps] = React.useState<DialogInterface[]>([]);
  const dialogRefs = React.useRef<any>({});

  const addDialogRefById = React.useCallback(
    (id: string | number, ref: React.RefObject<any>) => {
      const dialog = dialogs.find((d: any) => d.id === id);

      if (dialog != null) {
        dialogRefs.current[dialog.id] = {
          type: dialog.type,
          ref,
        };
      }
    },
    [dialogs]
  );

  const closeDialogById = React.useCallback((id: string | number) => {
    delete dialogRefs.current[id];
    setDialogProps((dialogs) => dialogs.filter((d) => !(d.id === id)));
  }, []);

  const setDialog = React.useCallback(
    ({ id, type = "dialog", ...props }: DialogInterface) => {
      setDialogProps((dialogs) => {
        if (type === "dialog") {
          dialogs = dialogs.filter((d) => d.type !== "dialog");
        }

        return [
          ...dialogs,
          {
            id,
            type,
            ...props,
          },
        ];
      });
    },
    []
  );

  return {
    dialogs,
    setDialog,
    closeDialogById,
    dialogRefs,
    addDialogRefById,
  };
};

const DialogProvider = ({
  children,
}: {
  children?: JSX.Element | JSX.Element[];
}) => {
  const dialogProps = useDialogProps();

  return (
    <DialogContext.Provider value={dialogProps}>
      {children}
    </DialogContext.Provider>
  );
};

export default DialogProvider;
